<script lang="ts">
  import type { SearchFilter } from "module/store/Filters";
  import type { SearchResultItemProps } from "../SearchControllers";

  let { resultItem, selected, callAction }: SearchResultItemProps = $props();

  let item = resultItem.item as SearchFilter;
</script>

<li class:search-selected={selected} class="no-icon-result">
  <a onclick={() => callAction({ item })}>
    <span class="title">@{item.tag}</span>
    <span class="sub">{item.subTitle}</span>
  </a>
</li>
